export default function SectionIcon({ children, title }) {
  return (
    <div className="flex items-center gap-2 mb-6">
      <div className="w-8 h-8 rounded-full bg-blue-btn-primary/5 flex items-center justify-center text-blue-btn-primary">
        {children}
      </div>
      <h2 className="text-lg font-bold">{title}</h2>
    </div>
  );
}